export {default} from './Input';
export type {IInputProps} from './Input';
